import { render, staticRenderFns } from "./bulk-messages-icon.vue?vue&type=template&id=793d7d0e"
import script from "./bulk-messages-icon.vue?vue&type=script&lang=js"
export * from "./bulk-messages-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports